import React from "react";
import PropTypes from "prop-types";

import { View, Image, Text } from "@react-pdf/renderer";

import styles from "./presona.styles";

const PersonaDescription = ({ persona }) => {
  const { text, img } = persona;

  return (
    <View style={styles.personaCard}>
      <Image style={styles.personaImage} src={img} />
      <View style={styles.personaTextContainer}>
        <Text style={styles.presonaText}>{text}</Text>
      </View>
    </View>
  );
};

PersonaDescription.propTypes = {
  persona: PropTypes.shape({
    img: PropTypes.shape({}),
    text: PropTypes.string
  }).isRequired
};

export default PersonaDescription;
